import React, { Component } from "react";
import client from "@culturehq/client";
import { ActionButton, Icon } from "@culturehq/components";

import { EventLink, ProfileLink } from "app/links";
import { Trans } from "app/utils";
import ChqModalConfirmDelete from "components/common/ChqModalConfirmDelete";

const DELETE_CALLS = {
  Photo: { call: client.deletePhoto, key: "photoId" },
  Comment: { call: client.deleteComment, key: "commentId" },
  Recognition: { call: client.deleteRecognition, key: "recognitionId" },
  Interest: { call: client.deleteInterest, key: "interestId" },
  Location: { call: client.deleteLocation, key: "locationId" },
  Company: { call: client.deleteCompany, key: "companyId" },
  Department: { call: client.deleteDepartment, key: "departmentId" },
  Endorsement: { call: client.deleteEndorsement, key: "endorsementId" },
  Post: { call: client.deletePost, key: "postId" },
  Announcement: { call: client.deleteAnnouncement, key: "announcementId" },
  Story: { call: client.deleteStory, key: "storyId" }
};

class FlagActions extends Component {
  handleToggleReview = () => {
    const { flag, onToggleReviewed } = this.props;

    onToggleReviewed(flag);
  };

  handleDelete = async () => {
    const { flag, onDeleted } = this.props;

    const { call, key } = DELETE_CALLS[flag.flaggableType];
    const options = { [key]: flag.flaggable.id };

    try {
      await call(options);
      onDeleted(flag);
    } catch (error) {
      if (error.status !== 404) {
        throw error;
      }
    }
  };

  render() {
    const { flag } = this.props;
    const type = flag.flaggableType;

    return (
      <div className="AdminFlags__row__actions">
        {!flag.reviewed && (
          <ActionButton icon="thumbsup" onClick={this.handleToggleReview}>
            <Trans>Mark as Reviewed</Trans>
          </ActionButton>
        )}

        {flag.reviewed && (
          <ActionButton icon="thumbsdown" onClick={this.handleToggleReview}>
            <Trans>Mark as Needs Review</Trans>
          </ActionButton>
        )}

        {type !== "User" && (
          <ChqModalConfirmDelete
            onAccept={this.handleDelete}
            trigger={onTrigger => (
              <ActionButton icon="ios-trash" onClick={onTrigger}>
                <Trans>Delete This {type}</Trans>
              </ActionButton>
            )}
          >
            <Trans>Are you sure you would like to delete this {type.toLowerCase()}?</Trans>
          </ChqModalConfirmDelete>
        )}

        {type === "User" && (
          <ProfileLink className="action link" user={flag.flaggable}>
            <Icon icon="person" />
            <Trans>See This {type}</Trans>
          </ProfileLink>
        )}

        {type === "Event" && (
          <EventLink event={flag.flaggable} className="action link">
            <Icon icon="ios-calendar-outline" />
            <Trans>See This {type}</Trans>
          </EventLink>
        )}
      </div>
    );
  }
}

export default FlagActions;
